// import checkType from '@/utils/checkType'
import Cookies from 'js-cookie'
export default {
  namespaced: true,
  state() {
    let wechat = Cookies.get('H3C_WECHAT')
    return {
      userInfo: null,
      user: {},
      wechatInfo: wechat ? JSON.parse(wechat) : {},
      navToken: '',
      muduUser: {}
    }
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
    getNavToken(state) {
      return state.navToken
    },
    getUser(state) {
      return state.user
    },
    //是否通过鉴权2
    passAuthentication2(state) {
      const auth2Keys = ['newIndustryId', 'company', 'job', 'h3cRelation']
      let flag = false
      //是否登录
      if (!state.user.id) return '1'
      // 是否通过鉴权2
      auth2Keys.forEach((item) => {
        if (!state.user[item]) {
          flag = '2'
        }
      })
      return flag
    },
    getMuduUser(state) {
      return state.muduUser
    },
    getWechat(state) {
      return state.wechatInfo
    }
  },
  mutations: {
    changeUserInfo(state, payload) {
      state.userInfo = JSON.parse(JSON.stringify(payload))
    },
    changeUser(state, payload) {
      state.user = JSON.parse(JSON.stringify(payload))
    },
    changeMuduUser(state, payload) {
      state.muduUser = JSON.parse(JSON.stringify(payload))
    },
    changeNavToken(state, payload) {
      state.navToken = payload
      // console.log(payload)
    },
    changeWechat(state, payload) {
      Cookies.set('H3C_WECHAT', JSON.stringify(payload), { expires: 30 })
      state.wechatInfo = JSON.parse(JSON.stringify(payload))
    }
  },
  actions: {}
}
